module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.addGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" New Group")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('draggable', {
    attrs: {
      "options": {
        handle: '.sort-row'
      }
    },
    on: {
      "update": function($event) {
        _vm.autoSave(_vm.localGroups, 'budget', 'save-order')
      }
    },
    model: {
      value: (_vm.localGroups),
      callback: function($$v) {
        _vm.localGroups = $$v
      },
      expression: "localGroups"
    }
  }, _vm._l((_vm.localGroups), function(group) {
    return (group.name != 'Surplus') ? _c('li', {
      staticClass: "list-group-item"
    }, [_c('i', {
      staticClass: "fa fa-fw fa-remove icon-button pull-right",
      on: {
        "click": function($event) {
          _vm.deleteItem('group', group.id)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-fw fa-arrows sort-row icon-button"
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-fw fa-plus icon-button",
      on: {
        "click": function($event) {
          _vm.addCategory(group)
        }
      }
    }), _vm._v(" "), (group.descEditable) ? _c('div', {
      staticClass: "control-wrapper"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (group.name),
        expression: "group.name"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "name": "name",
        "placeholder": "[Group Name]"
      },
      domProps: {
        "value": (group.name)
      },
      on: {
        "change": function($event) {
          _vm.autoSave(group, 'group', 'save')
        },
        "blur": function($event) {
          group.descEditable = false
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          group.name = $event.target.value
        }
      }
    })]) : _c('span', {
      staticClass: "group-label",
      on: {
        "click": function($event) {
          group.descEditable = true
        }
      }
    }, [_vm._v(" " + _vm._s(group.name))]), _vm._v(" "), (group.categories.length > 0) ? _c('ul', {
      staticClass: "list-group"
    }, _vm._l((group.categories), function(cat) {
      return _c('li', {
        staticClass: "list-group-item"
      }, [_c('i', {
        staticClass: "fa fa-fw fa-remove icon-button pull-right",
        on: {
          "click": function($event) {
            _vm.deleteItem('category', cat.id)
          }
        }
      }), _vm._v(" "), (cat.descEditable) ? _c('div', {
        staticClass: "control-wrapper"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cat.description),
          expression: "cat.description"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "text",
          "name": "description",
          "placeholder": "[Category Description]"
        },
        domProps: {
          "value": (cat.description)
        },
        on: {
          "change": function($event) {
            _vm.autoSave(cat, 'category', 'save')
          },
          "blur": function($event) {
            cat.descEditable = false
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            cat.description = $event.target.value
          }
        }
      })]) : _c('span', {
        on: {
          "click": function($event) {
            cat.descEditable = true
          }
        }
      }, [_vm._v(_vm._s(cat.description))])])
    })) : _vm._e()]) : _vm._e()
  }))], 1), _vm._v(" "), _c('spinner', {
    attrs: {
      "spinner-visible": _vm.spinnerVisible
    }
  }), _vm._v(" "), (_vm.confirmDialog.visible) ? _c('ModalDialog', {
    attrs: {
      "title": _vm.confirmDialog.title,
      "modal-visible": _vm.confirmDialog.visible,
      "confirm-button-text": _vm.confirmDialog.buttonText
    },
    on: {
      "confirm": function($event) {
        _vm.confirmationDialogResponse(true)
      },
      "closeModal": function($event) {
        _vm.confirmationDialogResponse(false)
      }
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.confirmDialog.message) + "\n\t")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cb67a994"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CategoryManager.vue
// module id = 170
// module chunks = 1